import React from 'react';
import { useLocation } from 'react-router';

interface ReadOnlyURLSearchParams extends URLSearchParams {
  append: never;
  set: never;
  delete: never;
  sort: never;
}

export function useSearchParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search) as ReadOnlyURLSearchParams, [search]);
}
